/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1
 */
export interface GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1
     */
    'cardType': GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1CardTypeEnum = typeof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1CardTypeEnum[keyof typeof GetCurrentCardAssociatedWithTheUserAccount200ResponseReissueOneOf1CardTypeEnum];


